import React, { FC } from 'react';
import {
  Box, Typography, Stack, IconButton,
} from '@mui/material';
import {
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import StyledButtonBase, {
  StyledCarousel,
} from 'views/rebranded-module/common/components/UI/RentalsCard/RentalsCard.styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { GrLocation } from 'react-icons/gr';
import {
  RiThumbUpLine,
  RiAlertLine,
  RiFireLine,
  RiForbidLine,
} from 'react-icons/ri';

const RentalsCard:FC<any> = (props) => {
  const {
    content,
    imagesGallery,
    image,
    name,
    make,
    imageAlt,
    startPrice,
    specsPath,
    title,
    id,
    handleCardClick = () => {},
    creditsCount,
    locationName,
    onMouseEnter,
    onMouseLeave,
    skipStartAtText = false,
    soldout,
    availableCount,
    tentative,
    valueDeal,
    location,
    /** E2E: stable hook on geo page (`BikeCardsSection` sets first card to `geo-bike-card-first`). */
    dataTestId,

  } = props;

  return (
    <StyledButtonBase
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      component={NavigatorLink}
      data-testid={dataTestId}
      onClick={() => {
        handleCardClick({ id, name, image });
      }}>
      <Box className="TCImgContainer">
        {imagesGallery?.length > 0 ? (
          <StyledCarousel
            deskTopItems={1}
            tabletItem={1}
            carouselArrow={false}
            showDots={imagesGallery.length > 1}
            tabletPartialVisibilityGutter={0}
            mobilePartialVisibilityGutter={0}>
            {imagesGallery.map((item) => (
              <Box height="100%" key={item.image.large_url}>
                <ImgBox
                  image={{
                    src:
                      item.image.large_url
                      || 'imgs/Rebranding/logos/default.jpg',
                    alt: item.image.imageAlt || name,
                  }}
                  width="100%"
                  height="100%"
                  objectFit={item.image.large_url ? 'contain' : 'cover'}
                  unoptimizedg
                />
              </Box>
            ))}
          </StyledCarousel>
        ) : (
          <ImgBox
            image={{
              src: image || 'imgs/Rebranding/logos/default.jpg',
              alt: imageAlt || name || title,
            }}
            width="100%"
            height="100%"
            objectFit={image ? 'contain' : 'cover'}
            unoptimized
          />
        )}
      </Box>

      <Stack className="RCInfoContainer">
        <Stack gap={1}>
          {locationName && (
            <Box display="flex">
              <GrLocation size={12} className="RCLocationIcon" />
              <Typography700
                variant="overline"
                component="p"
                lineHeight="120%"
                color="text.secondary">
                {location
                    && (
                    <>
                      {interpolateString(content.erLocationName, { location })}
                      {' • '}
                    </>
                    )}

                {locationName}

              </Typography700>

            </Box>
          )}
          <Typography700 className="RCTitle" variant="h7" component="p">
            {name || title}
          </Typography700>
          {make && (
            <Typography variant="body3" component="p" className="RCText">
              {make}
            </Typography>
          )}
        </Stack>
        {skipStartAtText ? (
          <Typography className="RCStartAt RCSkipStartAt" variant="body3" component="p">
            {interpolateString(content.pricePerDayText, {
              price: startPrice,
            })}
          </Typography>
        ) : creditsCount === undefined ? (
          <Typography
            variant="body3"
            component="p"
            className="RCStartAt"
            dangerouslySetInnerHTML={{
              __html: interpolateString(content.startingAt, {
                price: startPrice,
              }),
            }}
          />
        ) : (
          <Box display="flex">
            <Typography className="RCOldPrice" component="p" pr={1}>
              {interpolateString(content.pricePerDayText, {
                price: startPrice,
              })}
            </Typography>
            <Typography
              variant="body3"
              component="p"
              className="RCCreditsPerDay"
              dangerouslySetInnerHTML={{
                __html: interpolateString(content.creditsPerDayText, {
                  credits_num: creditsCount,
                }),
              }}
            />
          </Box>
        )}
      </Stack>
      {specsPath && (
        <IconButton
          className="RCBikeSpecs"
          onClick={(e) => {
            e.stopPropagation(); // This prevents the click from reaching the parent card
          }}>
          <InfoOutlinedIcon />
          <Typography700
            href={specsPath}
            target="_blank"
            component={NavigatorLink}
            className="RCBikeSpecsText">
            {content.viewBikeSpecs}
          </Typography700>
        </IconButton>
      )}
      {soldout && (
        <Box className="RCDummyLayer" />
      )}
      {soldout && (
        <Box className="RCSatus RCSoldout">
          <RiForbidLine />
          <Typography700 component="span" className="RCSatusText">
            {content.soldOutLabel}
          </Typography700>
        </Box>
      )}
      {!!availableCount && (
        <Box className="RCSatus RCHurry">
          <RiFireLine />
          <Typography700 component="span" className="RCSatusText">
            {interpolateString(content.leftedVehicleOnPriceLabel, {
              v_num: 8,
            })}
          </Typography700>
        </Box>
      )}
      {tentative && !availableCount && (
        <Box className="RCSatus RCTentative">
          <RiAlertLine />
          <Typography700 component="span" className="RCSatusText">
            {content.limitedAvailabilityLabel}
          </Typography700>
        </Box>
      )}
      {!availableCount && !soldout && !tentative && valueDeal && (
        <Box className="RCSatus RCValueDeal">
          <RiThumbUpLine />
          <Typography700 component="span" className="RCSatusText">
            {content.valueDealLabel}
          </Typography700>
        </Box>
      )}
    </StyledButtonBase>
  );
};

export { RentalsCard };